module.exports = __webpack_public_path__ + "img/wifi.94f49c70.svg";